import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-heat-pump',
  templateUrl: './heat-pump.component.html',
  styleUrls: ['./heat-pump.component.scss']
})
export class HeatPumpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
